import AnalyticsPage from './AnalyticsPage';

export default AnalyticsPage;
